import { Action } from 'redux';

import { UpdateLastSeenUserNotification, UpdateLastSeenUserNotificationSucceeded } from '../../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../../bootstrap/redux/actions/isActionFactory';

export interface UpdateLastSeenUserNotificationAction extends Action {
  // TODO: decide what the client wants to send to server
  lastSeenUserNotificationId: string;
}

export interface UpdateLastSeenUserNotificationSucceededAction extends Action { }

export function updateLastSeenUserNotificationAction(lastSeenUserNotificationId: string) {
  return {
    lastSeenUserNotificationId: lastSeenUserNotificationId,
    type: UpdateLastSeenUserNotification,
  };
}

export function updateLastSeenUserNotificationSucceededAction() {
  return {
    type: UpdateLastSeenUserNotificationSucceeded
  };
}

export const isUpdateLastSeenUserNotificationAction = isActionFactory<UpdateLastSeenUserNotificationAction>(UpdateLastSeenUserNotification);

export const isUpdateLastSeenUserNotificationSucceededAction = isActionFactory<UpdateLastSeenUserNotificationSucceededAction>(UpdateLastSeenUserNotificationSucceeded);
